"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyLinkModal = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const copyCurrentUrl_1 = require("../../../utils/copyCurrentUrl");
const useShortenedLink_1 = __importDefault(require("../../../utils/useShortenedLink"));
const ModalInput_1 = require("./atoms/ModalInput");
const Modals_style_1 = require("./Modals.style");
const BITLY_ACCESS_TOKEN = process.env.BITLY_ACCESS_TOKEN || "";
const initialCopyLinkModalData = {
    link: window.location.href,
};
const CopyLinkModal = ({ onSubmit, onError }) => {
    const focusInputRef = (0, react_1.useRef)(null);
    const { t } = (0, react_i18next_1.useTranslation)();
    const { shortenedLink, error } = (0, useShortenedLink_1.default)(window.location.href, BITLY_ACCESS_TOKEN);
    const [formState, setFormState] = (0, react_1.useState)(initialCopyLinkModalData);
    (0, react_1.useEffect)(() => {
        if (error) {
            onError(error);
        }
        else {
            setFormState((prevFormData) => (Object.assign(Object.assign({}, prevFormData), { link: shortenedLink })));
        }
    }, [shortenedLink, error, onError]);
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormState((prevFormData) => (Object.assign(Object.assign({}, prevFormData), { [name]: value })));
    };
    const handleSubmit = (event) => {
        onSubmit(formState);
        (0, copyCurrentUrl_1.copyCurrentURL)(formState.link);
        setFormState(initialCopyLinkModalData);
    };
    return (react_1.default.createElement("form", { onSubmit: handleSubmit },
        react_1.default.createElement(Modals_style_1.FormWrapper, { className: "active-overlay" },
            react_1.default.createElement(ModalInput_1.ModalInput, { focusInputRef: focusInputRef, value: formState.link, onChange: handleInputChange, name: "link", type: "text" }),
            react_1.default.createElement(Modals_style_1.BlueButton, { type: "submit", "aria-label": t("copyLinkModal.copyLink") }, t("copyLinkModal.copyLink")))));
};
exports.CopyLinkModal = CopyLinkModal;
